import { isNil } from 'lodash'

import {
  ADDITIONAL_INGREDIENT_TYPE,
  AI_HIGHLIGHT_STYLES,
  AI_INGREDIENT_MATCH_TYPE,
} from '../../common/constants'

import { DISH_FIELDS_CONFIG } from '../constants'

const getPriorityFromOriginOfIngredient = originField => {
  if (originField === DISH_FIELDS_CONFIG.NAME.value) {
    return 1
  }

  if (originField === DISH_FIELDS_CONFIG.DESCRIPTION.value) {
    return 3
  }

  if (originField === DISH_FIELDS_CONFIG.INGREDIENTS.value) {
    return 4
  }

  return 2
}

const getHighlightValueFromIngredient = ingredient => {
  if (ingredient.type === ADDITIONAL_INGREDIENT_TYPE.DEFINITE) {
    return AI_HIGHLIGHT_STYLES.defaultBlue.value
  }

  if (ingredient.type === ADDITIONAL_INGREDIENT_TYPE.PROBABLE) {
    return AI_HIGHLIGHT_STYLES.probable.value
  }

  if (ingredient.alternativeType) {
    return AI_HIGHLIGHT_STYLES.alternativeType.value
  }

  if (ingredient.isSuggestedUsingMl && !ingredient.isSuggestedUsingParser) {
    return AI_INGREDIENT_MATCH_TYPE.ML_SUGGESTED
  }

  if (!isNil(ingredient.matchType)) {
    return ingredient.matchType
  }

  return null
}

export const transformMainOrChoiceIngredientForDisplay = ingredient => ({
  ...ingredient,
  priority: ingredient.originField
    ? getPriorityFromOriginOfIngredient(ingredient.originField)
    : 5,
  highlight: getHighlightValueFromIngredient(ingredient),
})

export const transformAdditionalIngredientForDisplay = ingredient => ({
  ...ingredient,
  highlight: getHighlightValueFromIngredient(ingredient),
})
